import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import * as actions from '../../store/actions/actions'

import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Container, FormGroup, Input, Row} from "reactstrap";
import Col from "react-bootstrap/Col";
import {FormControl} from "react-bootstrap";
import "./user.css"
import "react-toggle/style.css"
import * as Roles from "../../store/actions/roles";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import italianUserEditTranslations from "../../translations/user/edit/it.user.edit.json";
import englishUserEditTranslations from "../../translations/user/edit/en.user.edit.json";

class UserEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianUserEditTranslations, "it");
    this.props.addTranslationForLanguage(englishUserEditTranslations, "en");
  }


  componentDidMount() {

    this.props.fetchCorporates()

    if(this.props.role === Roles.BANK_CORPORATE_ADMIN){
      this.props.fetchUserCorporates(this.props.idBank,Roles.BANK_CORPORATE_ADMIN,this.props.corporates)
    }else if(this.props.role===Roles.BANK_ADMIN){
      this.props.fetchUserCorporates(this.props.idBank,Roles.BANK_ADMIN,this.props.corporates)
    }
    this.props.fetchRoles()
    this.props.fetchBanks()
  }


  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = (event) => {
    event.preventDefault();
    this.props.updateUser(this.props.userToUpdate)
  }

  // checkUserCorporate=(senderId)=>{
  //   let response=false;
  //   if(undefined !== this.props.allUserCorporates){
  //     this.props.allUserCorporates.map((item)=>{
  //       if(item===senderId){
  //         response=true;
  //       }
  //     })
  //   }
  //   return response;
  // }
  //
  // getCorporatePermissionList=()=>{
  //   var permissionList=[];
  //
  //   this.props.corporates.map((item)=>{
  //     // if(this.props.userCorporates.length>0){
  //     if(this.checkUserCorporate(item.corporateSenderId) === true){
  //       var corporate={
  //         corporateSenderName:item.corporateSenderName,
  //         corporateSenderId:item.corporateSenderId,
  //         read:false,
  //         write:false
  //       }
  //       permissionList.push(corporate)
  //     }
  //       // }
  //   })
  //   let finalList=[];
  //   if(this.props.userCorporates.length>0){
  //     // permissionList=permissionList.
  //     this.props.userCorporates.map((userCorp)=>{
  //       finalList=permissionList.map((corporatePerm)=>{
  //         if(corporatePerm.corporateSenderId===userCorp.corporateSenderId){
  //           corporatePerm.read=userCorp.read;
  //           corporatePerm.write=userCorp.write;
  //           // finalList.push(corporatePerm);
  //           return corporatePerm
  //
  //         }else{
  //
  //           // finalList.push(corporatePerm);
  //           return corporatePerm
  //         }
  //       })
  //     })
  //   }else{
  //
  //     finalList=permissionList;
  //
  //   }
  //
  //   this.props.permissionListUpdate(finalList)
  //   // return permissionList;
  // }

  render() {
    let corporatePermissionList=this.props.permissionList;


    let errors="";
    errors=this.props.validationError;
    let nameError = ""
    let userNameError=""
    //let roleError=""
    let emailError="";
    let passwordError="";
    let phoneError = "";
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field === 'fullName')
            nameError=item.defaultMessage;
          if(item.field === 'username')
            userNameError=item.defaultMessage;
          if(item.field === 'email')
            emailError=item.defaultMessage;
          if(item.field === 'password')
            passwordError=item.defaultMessage;
          //if(item.field === 'role')
          //  roleError=item.defaultMessage;
          if(item.field === 'phone')
            phoneError=item.defaultMessage;
          return ""
        });
      }
    }

    let distintaSection =  this.props.authenticatedUserRole !== Roles.BANK_SUPER_ADMIN ? null :
        <FormGroup>
            <label className="form-control-label" htmlFor="distinteSection">
              <Translate id="user.edit.distinteSection"/>
            </label>
            <br></br>
            <input type="checkbox"
                   disabled={this.checkDistinteSection()}
                   value={this.props.distinteSection}
                   checked={ this.props.distinteSection }
                   onChange={(event) => this.onDistinteSectionChange(event.target.checked) } />
          </FormGroup>

    let userToCreateRole = this.props.role;
    // let corporateDisabled=Roles.checkDisabled(userToCreateRole,Roles.MODULE_CORPORATE);
    let corporateRequired=Roles.checkRequired(userToCreateRole,Roles.MODULE_CORPORATE);
    let bankDisabled=Roles.checkDisabled(userToCreateRole,Roles.MODULE_BANK)
    let bankRequired=Roles.checkRequired(userToCreateRole,Roles.MODULE_BANK)

    let authenticatedUserRole=this.props.authenticatedUserRole;
    let corporatePermissionPannel= authenticatedUserRole===Roles.BANK_SUPER_ADMIN &&
    (userToCreateRole === Roles.BANK_CORPORATE_ADMIN || userToCreateRole === Roles.BANK_ADMIN) ?
    <Row>
      <Col lg="12">
        <Card className="shadow">
          <CardHeader className="border-0">
            <div style={{textAlign:'center'}}><Translate id="user.edit.permission.heading"/></div>
          </CardHeader>
          <CardBody>
            <Row>
              <table className="table">
                <tr>
                  <th ><Translate id="user.edit.permission.corporate"/></th>
                  <th style={{textAlign:'center'}}><Translate id="user.edit.permission.read"/></th>
                  <th style={{textAlign:'center'}}><Translate id="user.edit.permission.write"/></th>
                </tr>
                {corporatePermissionList.map((item)=>{
                  return    <tr>
                    <td>{item.corporateSenderName}</td>
                    <td style={{textAlign:'center'}}><input id="corporateRead"  type="checkbox" onChange={(event) => this.onChangeRead(event.target)} value={item.corporateSenderId} checked={item.read}/></td>
                    <td style={{textAlign:'center'}}><input id="corporateWrite" type="checkbox" value={item.corporateSenderId} checked={item.write} onChange={(event) => this.onChangeWrite(event.target)}/></td>
                  </tr>
                })}
              </table>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row> : ""

    return (
      <>
          <Header />
          <Container className="mt--5" fluid>
            {/* Table */}
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="user.edit.title" data={{ username: this.props.username }}/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="fullName">
                                <Translate id="user.edit.name"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.fullName}
                                  onChange={this.onFullNameChange}
                                  id="fullName"
                                  placeholder={translate("user.edit.name")}
                                  type="text"/>}
                              </Translate>
                              { nameError.length > 0 ? <label style={{color:"red"}}><Translate id={nameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.edit.userName"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                      disabled
                                  className={userNameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.username}
                                  onChange={this.onUsernameChange}
                                  id="username"
                                  placeholder={translate("user.edit.userName")}
                                  type="text"/>}
                              </Translate>
                              { userNameError.length > 0 ? <label style={{color:"red"}}><Translate id={userNameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="password">
                                <Translate id="user.edit.password"/>
                              </label>
                              <br></br>
                              <small><span className="underlineClick" onClick={this.resetPassword}>
                              <Translate id="user.edit.password.reset"/>
                              </span></small>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                      disabled
                                  className={passwordError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.password}
                                  onChange={this.onPasswordChange}
                                  id="password"
                                  placeholder={translate("user.edit.password")}
                                  type="text"/>}
                              </Translate>

                              { passwordError.length > 0 ? <label style={{color:"red"}}><Translate id={passwordError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="password">
                                <Translate id="user.edit.phone"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className="form-control-alternative"
                                  value={this.props.phone}
                                  onChange={this.onPhoneChange}
                                  id="phone"
                                  placeholder={translate("user.edit.phone")}
                                  type="text"/>}
                              </Translate>
                              { phoneError.length > 0 ? <label style={{color:"red"}}><Translate id={phoneError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="password">
                                <Translate id="user.edit.email"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={emailError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.email}
                                  onChange={this.onEmailChange}
                                  disabled
                                  id="email"
                                  placeholder={translate("user.edit.email")}
                                  type="text"/>}
                              </Translate>
                              { emailError.length > 0 ? <label style={{color:"red"}}><Translate id={emailError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="password">
                                <Translate id="user.edit.description"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className="form-control-alternative"
                                  value={this.props.description}
                                  onChange={this.onDescriptionChange}
                                  id="description"
                                  placeholder={translate("user.edit.description")}
                                  type="text"/>}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="language">
                                <Translate id="user.edit.language"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <FormControl as="select"
                                               onChange={(newValue) => {
                                                 this.props.onLanguagePreferenceChange(newValue.target.value);
                                               }}>
                                    <option></option>
                                    {this.props.languages.map((item)=>{
                                      if(item.code=== this.props.language){
                                        return <option value={item.code} selected="selected">{translate(item.code)}</option>
                                      }else{
                                        return <option value={item.code}>{translate(item.code)}</option>
                                      }
                                    })}
                                  </FormControl>}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="reportSection">
                                <Translate id="user.edit.reportSection"/>
                              </label>
                              <br></br>
                              <input type="checkbox"
                                     value={this.props.reportSection}
                                     checked={ this.props.reportSection }
                                     onChange={(event) => this.onReportSectionChange(event.target.checked) } />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            {distintaSection}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="password">
                                <Translate id="user.edit.role"/>
                              </label>
                              <FormControl className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                           as="select"
                                           required
                                           disabled
                                           onChange={(newValue) => {
                                             this.onRoleChange(newValue.target.value);
                                           }}>
                                {this.props.roles.map((item)=>{
                                  if(item.value === this.props.role){
                                    return <option value={item.value} selected="selected">{item.value}</option>
                                  }else{
                                    return <option value={item.value}>{item.value}</option>
                                  }

                                })}
                              </FormControl>
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="bank">
                                <Translate id="user.edit.bankName"/>
                              </label>
                              <FormControl as="select"
                                           // disabled={bankDisabled}
                                           required={bankRequired}
                                           disabled
                                           onChange={(newValue) => {
                                             this.onIdBankChange(newValue.target.value);
                                           }}>
                                <option selected={bankDisabled}></option>
                                {this.props.banks.map((item)=>{
                                    if(item.bankId=== this.props.idBank){
                                      return <option value={item.bankId+":"+item.bankName} selected="selected" >{item.bankName}</option>
                                    }else{
                                      return <option value={item.bankId+":"+item.bankName} >{item.bankName}</option>
                                    }
                                })}
                              </FormControl>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="bank">
                                <Translate id="user.edit.corporateName"/>
                              </label>
                              <FormControl as="select"
                                           // disabled={corporateDisabled}
                                           required={corporateRequired}
                                           disabled
                                           onChange={(newValue) => {
                                             this.onCorporateSenderIdChange(newValue.target.value);
                                           }}>
                                <option></option>
                                {this.props.corporates.map((item)=>{
                                  if(item.corporateSenderId===this.props.corporateSenderId){
                                    return <option value={item.corporateSenderId+":"+item.corporateSenderName} selected="selected">{item.corporateSenderName}</option>
                                  }else{
                                    return <option value={item.corporateSenderId+":"+item.corporateSenderName}>{item.corporateSenderName}</option>
                                  }

                                })}
                              </FormControl>
                            </FormGroup>
                          </Col>
                        </Row>
                        {corporatePermissionPannel}
                        <hr></hr>
                        <Row>
                          <Col align="left">
                            <Button onClick={this.onBackClick} variant="contained">
                              <i className="fas fa-arrow-left text-primary" />
                            </Button>
                          </Col>
                          <Col align="right">
                            <Button  type="submit" className="btn-success" variant="contained" >
                              <Translate id="user.edit.update.button" data={{ username: this.props.username }}/>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }
  onChangeRead=(input)=>{
    // var [corporateList]=this.props.userCorporates
    var corporates=this.props.permissionList
    var permissionList=[];

    if(this.props.userCorporates.length>0){
      permissionList=corporates.map((item)=>{
        if(item.corporateSenderId===input.value){

          item.read=input.checked
          return item;
          // permissionList.push(item);
      }else{
          var corporate={
            corporateSenderId:input.value,
            read:input.checked,
            write:false
          }
          // permissionList.push(corporate);
        }
      })
    }else{
      permissionList=corporates.map((item)=>{
        if(item.corporateSenderId===input.value){

          item.read=input.checked
          return item;
          // permissionList.push(item);
        }else{
          // var corporate={
          //   corporateSenderId:input.value,
          //   read:input.checked,
          //   write:false
          // }
          // permissionList.push(corporate);
          return item;
        }
      })
    }

    this.props.corporatePermissionsChange(permissionList)
    // corporateList.add()

  }
  //
  onChangeWrite=(input)=>{
    var corporates=this.props.permissionList
    var permissionList=[];

    if(this.props.userCorporates.length>0){
      permissionList = corporates.map((item)=>{
        if(item.corporateSenderId===input.value){
          item.write=input.checked
          item.read=input.checked
          return item
          // permissionList.push(item);
        }else{
          // var corporate={
          //   corporateSenderId:item.value,
          //   read:false,
          //   write:item.checked
          // }
          // return corporate;
          return item;
          // permissionList.push(corporate);
        }
      })
    }else{
      permissionList=corporates.map((item)=>{
        if(item.corporateSenderId===input.value){
          item.write=input.checked
          item.read=input.checked
          // permissionList.push(item);
          return item
        }else{
          // var corporate={
          //   corporateSenderId:input.value,
          //   read:false,
          //   write:input.checked
          // }
          // debugger
          // return corporate;
          return item;
          // permissionList.push(corporate);
        }
      })
    }

    this.props.corporatePermissionsChange(permissionList)
  }

  checkRead=(input)=>{
    //console.log(input)
  }
  checkWrite=(input)=>{
    //console.log(input)
  }


  onRoleChange = (role) => {
    this.props.roleChange(role)
    if(role === Roles.PAYDO_ADMIN){
      this.onIdBankChange("");
      this.onCorporateSenderIdChange("");
    }else if(role === Roles.BANK_ADMIN || role === Roles.BANK_AUTHORIZER){
      this.onCorporateSenderIdChange("")
    }
    this.checkDistinteSection()
  }


  onIdBankChange = (idBank) => {
    if(idBank !== 'undefined')
      this.props.idBankChange(idBank)
  }

  onCorporateSenderIdChange = (corporateSenderId) => {
    if(corporateSenderId !== 'undefined')
      this.props.corporateSenderIdChange(corporateSenderId)
  }

  onEnabledChange = (event) => {
    let enabled = event.target.value === "true" ? true : false
    this.props.enabledChange(enabled)
  }

  onFullNameChange = (event) => {
    let fullName = event.target.value
    this.props.fullNameChange(fullName)
  }

  onDescriptionChange = (event) => {
    let description = event.target.value
    this.props.descriptionChange(description)
  }

  onUsernameChange = (event) => {
    let username = event.target.value
    this.props.usernameChange(username)
  }

  onPasswordChange = (event) => {
    let password = event.target.value
    this.props.passwordChange(password)
  }

  resetPassword=()=>{
    this.props.resetUser(this.props.userToUpdate);
  }

  onPhoneChange = (event) => {
    let phone = event.target.value
    this.props.phoneChange(phone)
  }

  onEmailChange = (event) => {
    let email = event.target.value
    this.props.emailChange(email)
  }

  onResetChange = (event) => {
    let reset = event.target.value === "true" ? true : false
    this.props.resetChange(reset)
  }

  onReportSectionChange = (reportSection) => {
    if(reportSection ===true) {
      this.props.reportSectionChange(true)
    } else if(reportSection ===false) {
      this.props.reportSectionChange(false)
    }
  }

  onDistinteSectionChange = (distinteSection) => {
    if (distinteSection === true) {
      this.props.distinteSectionChange(true)
    } else if (distinteSection === false) {
      this.props.distinteSectionChange(false)
    }
  }

  checkDistinteSection() {
    if (this.props.authenticatedUserRole === Roles.BANK_SUPER_ADMIN) {
      if (this.props.role === Roles.BANK_ADMIN || this.props.role === Roles.BANK_CORPORATE_ADMIN) {
        return false;
      }
    }
    return true;
  }
}

const mapStateToProps = state => {
  return {
    userToUpdate: state.userEdit.userToEdit,
    idBank: state.userEdit.userToEdit.idBank,
    corporateSenderId: state.userEdit.userToEdit.corporateSenderId,
    fullName: state.userEdit.userToEdit.fullName,
    description: state.userEdit.userToEdit.description,
    userCorporates: state.userEdit.userToEdit.userCorporates,
    allUserCorporates: state.userEdit.allUserCorporates,
    permissionList: state.userEdit.permissionList,
    enabled: state.userEdit.userToEdit.enabled === true ? "true" : "false",
    username: state.userEdit.userToEdit.username,
    password: state.userEdit.userToEdit.password,
    language: state.userEdit.userToEdit.language,
    phone: state.userEdit.userToEdit.phone,
    email: state.userEdit.userToEdit.email,
    reset: state.userEdit.userToEdit.reset === true ? "true" : "false",
    reportSection: state.userEdit.userToEdit.reportSection,
    distinteSection: state.userEdit.userToEdit.distinteSection,
    role: state.userEdit.userToEdit.role,
    roles: state.role.roles,
    banks: state.bank.banks,
    corporates: state.corporate.corporates,
    validationError:state.userEdit.error,
    languages: state.localize.languages,
    authenticatedUserRole : state.authentication.authenticatedUser.role
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateUser: (user) => dispatch({ type: actions.UPDATE_USER_EDIT_REQUEST, value: user }),
    idBankChange: (idBank) => dispatch({ type: actions.EDIT_USER_ID_BANK_FIELD_CHANGE_REQUEST, value: idBank }),
    corporateSenderIdChange: (corporateSenderId) => dispatch({ type: actions.EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST, value: corporateSenderId }),
    fullNameChange: (fullName) => dispatch({ type: actions.EDIT_USER_FULL_NAME_FIELD_CHANGE_REQUEST, value: fullName }),
    descriptionChange: (description) => dispatch({ type: actions.EDIT_USER_DESCRIPTION_FIELD_CHANGE_REQUEST, value: description }),
    enabledChange: (enabled) => dispatch({ type: actions.EDIT_USER_ENABLED_FIELD_CHANGE_REQUEST, value: enabled }),
    usernameChange: (username) => dispatch({ type: actions.EDIT_USER_USERNAME_FIELD_CHANGE_REQUEST, value: username }),
    passwordChange: (password) => dispatch({ type: actions.EDIT_USER_PASSWORD_FIELD_CHANGE_REQUEST, value: password }),
    phoneChange: (phone) => dispatch({ type: actions.EDIT_USER_PHONE_FIELD_CHANGE_REQUEST, value: phone }),
    emailChange: (email) => dispatch({ type: actions.EDIT_USER_EMAIL_FIELD_CHANGE_REQUEST, value: email }),
    resetChange: (reset) => dispatch({ type: actions.EDIT_USER_RESET_FIELD_CHANGE_REQUEST, value: reset }),
    corporatePermissionsChange: (reset) => dispatch({ type: actions.EDIT_USER_CORPORATE_PERMISSION_CHANGE_REQUEST, value: reset }),
    // permissionListUpdate:(list)=>dispatch({type:actions.EDIT_USER_CORPORATE_PERMISSION_LIST_REQUEST,value:list}),
    roleChange: (role) => dispatch({ type: actions.EDIT_USER_ROLE_FIELD_CHANGE_REQUEST, value: role }),
    fetchRoles: () => dispatch({ type: actions.FETCH_ROLES_REQUEST }),
    reportSectionChange: (reportSection) => dispatch({ type: actions.EDIT_USER_REPORT_SECTION_FIELD_CHANGE, value: reportSection }),
    distinteSectionChange: (distinteSection) => dispatch({ type: actions.EDIT_USER_DISTINTE_SECTION_FIELD_CHANGE, value: distinteSection }),
    fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
    fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
    fetchUserCorporates: (idBank,role,corporates) => dispatch({ type: actions.FETCH_USER_CORPORATES_REQUEST ,value:{idBank:idBank,role:role,corporates:corporates}}),
    resetUser: (user) => dispatch({ type: actions.USER_DETAIL_RESET_REQUEST ,value:user}),
    onLanguagePreferenceChange: (language) => dispatch({ type: actions.EDIT_USER_LANGUAGE_FIELD_CHANGE_REQUEST, value: language }),
    // updatePermissionListState:(corporates,allUserCorporates,userCorporates) => dispatch({ type: actions.EDIT_USER_CORPORATE_PERMISSION_LIST_REQUEST ,value:{corporates:corporates,allUserCorporates:allUserCorporates,userCorporates:userCorporates}}),

  };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(UserEdit));